import { render, staticRenderFns } from "./MinigamesTournamentLabel.vue?vue&type=template&id=e9fcf15c&scoped=true"
import script from "./MinigamesTournamentLabel.vue?vue&type=script&lang=js"
export * from "./MinigamesTournamentLabel.vue?vue&type=script&lang=js"
import style0 from "./MinigamesTournamentLabel.vue?vue&type=style&index=0&id=e9fcf15c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fcf15c",
  null
  
)

export default component.exports